<template>
    <nav class="breadcrumb-nav" aria-label="Breadcrumb">
        <ol class="breadcrumb-list">
            <li v-for="(item, index) in items" :key="index" class="breadcrumb-item">
                <router-link 
                    v-if="item.path" 
                    :to="item.path" 
                    class="breadcrumb-link"
                >
                    {{ item.label }}
                </router-link>
                <span v-else class="breadcrumb-current">
                    {{ item.label }}
                </span>
                <span v-if="index < items.length - 1" class="breadcrumb-separator">
                    <svg class="separator-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                </span>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    name: "bread-crumb",
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.breadcrumb-nav {
    width: 100%;
}

.breadcrumb-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    list-style: none;
    padding: 0;
    margin: 0;
}

.breadcrumb-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.breadcrumb-link {
    font-size: 0.875rem;
    font-weight: 500;
    color: #64748b;
    text-decoration: none;
    transition: all 0.2s ease;
    padding: 0.25rem 0.5rem;
    border-radius: 0.375rem;

    &:hover {
        color: #499DD4;
        background-color: #f1f5f9;
    }

    &:active {
        color: #394867;
    }

    @media (min-width: 640px) {
        font-size: 0.9375rem;
    }
}

.breadcrumb-current {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1e293b;
    padding: 0.25rem 0.5rem;

    @media (min-width: 640px) {
        font-size: 0.9375rem;
    }
}

.breadcrumb-separator {
    display: flex;
    align-items: center;
    color: #cbd5e1;
    flex-shrink: 0;
}

.separator-icon {
    width: 1rem;
    height: 1rem;
    transition: color 0.2s ease;
}

.breadcrumb-item:hover .separator-icon {
    color: #94a3b8;
}
</style>